import { Action, CaseReducer, Draft, EntityState } from '@reduxjs/toolkit';
import { FulfilledUploadAction, PendingUploadAction, RejectedUploadAction } from '@ff-os/shared-utils/types/private-assets/uploadAction';
import { unwrap } from '@ff-os/shared-utils/unwrap';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { PhotoPrintsUploadContext } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsUploadContext';
import { addOneReducer } from '../photosSlice';

type PhotoPrintCaseReducer<T extends Action> = CaseReducer<EntityState<PhotoPrintsJson.Photo>, T>;

export const handlePending: PhotoPrintCaseReducer<PendingUploadAction<PhotoPrintsUploadContext>> = ((
    state, action
) => {
    const requestContext = action.meta.arg.context;

    const photo: PhotoPrintsJson.UnprocessedPhoto = {
        id: requestContext.id,
        groupId: requestContext.groupId,
        assetId: requestContext.assetId,
        quantity: 1,
        processed: false,
        assetSource: 'local',
        status: 'saving',
        filter: null
    };

    if (requestContext.processed) {
        addOneReducer(state, {
            ...photo,
            processed: requestContext.processed,
            localUrl: requestContext.localUrl!,
            width: requestContext.imageWidth!,
            height: requestContext.imageHeight!,
            crop: {
                x: 0,
                y: 0,
                width: requestContext.imageWidth!,
                height: requestContext.imageHeight!
            }
        });
    } else {
        addOneReducer(state, photo);
    }
});

export const handleRejected: PhotoPrintCaseReducer<RejectedUploadAction<PhotoPrintsUploadContext>> = ((
    state, action
) => {

    const requestMeta = action.meta.arg.context;
    const idsToUpdate = unwrap(state)
        .filter(p => p.assetId === requestMeta.assetId)
        .map(p => p.id);

    for (const idToUpdate of idsToUpdate) {
        const photo = state.entities[idToUpdate]!;
        photo.status = 'error';
    }
});

export const handleFulfilled: PhotoPrintCaseReducer<FulfilledUploadAction<PhotoPrintsUploadContext>> = (
    state, action
) => {

    const requestMeta = action.meta.arg.context;
    const idsToUpdate = unwrap(state)
        .filter(p => p.assetId === requestMeta.assetId)
        .map(p => p.id);

    for (const idToUpdate of idsToUpdate) {

        const photo = state.entities[idToUpdate]! as Draft<PhotoPrintsJson.ProcessedPhoto>;

        photo.processed = true;
        photo.status = 'saved';
        photo.assetId = action.payload.assetId;
        photo.assetSource = 'private';

        const { width, height } = action.payload.meta;

        if (!requestMeta.localUrl) {

            photo.width = width;
            photo.height = height;
            photo.crop = {
                x: 0,
                y: 0,
                width,
                height
            };

        } else if (width === photo.height && height === photo.width) {

            // Fix images with xmp tag orientations 5 - 8 #17453

            photo.width = width;
            photo.height = height;
            photo.crop = {
                x: 0,
                y: 0,
                width,
                height
            };
        }
    }
};